/**
 * @generated SignedSource<<e67c3776a1f0cb9a230249ce9807b077>>
 * @relayHash 5bca99fd4d034350fb6444fd0005b5bb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 01a79c2e48f39df6dd06b0b3839ffec2f865d8fc3e907a9fac8206ff06467038

import type { ConcreteRequest, Query } from 'relay-runtime';
export type DeploymentState = "CANCELLED" | "FAILED" | "IN_PROGRESS" | "PENDING" | "ROLLED_BACK" | "SUCCESSFUL" | "UNKNOWN" | "%future added value";
export type DevOpsEnvironmentCategory = "DEVELOPMENT" | "PRODUCTION" | "STAGING" | "TESTING" | "UNMAPPED" | "%future added value";
export type JiraReleasesDeploymentFilter = {
  environmentCategories?: ReadonlyArray<DevOpsEnvironmentCategory> | null | undefined;
  environmentDisplayNames?: ReadonlyArray<string> | null | undefined;
  issueIds?: ReadonlyArray<string> | null | undefined;
  serviceIds?: ReadonlyArray<string> | null | undefined;
  timeWindow: JiraReleasesTimeWindowInput;
};
export type JiraReleasesTimeWindowInput = {
  after: AGG$DateTime;
  before: AGG$DateTime;
};
export type mainDeploymentsQuery$variables = {
  after?: string | null | undefined;
  filter: JiraReleasesDeploymentFilter;
  first: number;
};
export type mainDeploymentsQuery$data = {
  readonly jiraReleases: {
    readonly deployments: {
      readonly edges: ReadonlyArray<{
        readonly cursor: string;
        readonly node: {
          readonly deploymentSequenceNumber: AGG$Long | null | undefined;
          readonly description: string | null | undefined;
          readonly displayName: string | null | undefined;
          readonly environment: {
            readonly category: DevOpsEnvironmentCategory | null | undefined;
            readonly displayName: string | null | undefined;
          } | null | undefined;
          readonly id: string;
          readonly issueIds: ReadonlyArray<string> | null | undefined;
          readonly lastUpdated: AGG$DateTime | null | undefined;
          readonly pipeline: {
            readonly displayName: string | null | undefined;
            readonly url: string | null | undefined;
          } | null | undefined;
          readonly state: DeploymentState | null | undefined;
          readonly updateSequenceNumber: AGG$Long | null | undefined;
          readonly url: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    } | null | undefined;
  } | null | undefined;
};
export type mainDeploymentsQuery = {
  response: mainDeploymentsQuery$data;
  variables: mainDeploymentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v4 = {
  "kind": "ScalarField",
  "name": "url"
},
v5 = [
  {
    "concreteType": "JiraReleases",
    "kind": "LinkedField",
    "name": "jiraReleases",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
          },
          {
            "kind": "Variable",
            "name": "filter",
            "variableName": "filter"
          },
          {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
          }
        ],
        "concreteType": "JiraReleasesDeploymentSummaryConnection",
        "kind": "LinkedField",
        "name": "deployments",
        "plural": false,
        "selections": [
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          },
          {
            "concreteType": "JiraReleasesDeploymentSummaryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "cursor"
              },
              {
                "concreteType": "DeploymentSummary",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "issueIds"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "deploymentSequenceNumber"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "updateSequenceNumber"
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "state"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "lastUpdated"
                  },
                  {
                    "concreteType": "DeploymentPipeline",
                    "kind": "LinkedField",
                    "name": "pipeline",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "DevOpsEnvironment",
                    "kind": "LinkedField",
                    "name": "environment",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "category"
                      },
                      (v3/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainDeploymentsQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainDeploymentsQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "id": "01a79c2e48f39df6dd06b0b3839ffec2f865d8fc3e907a9fac8206ff06467038",
    "metadata": {},
    "name": "mainDeploymentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0e91b6bc7d847a5a5fcb18b033c10caa";

export default node;
